import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';
import { App } from '@df/core/app';
import { BasketService, IAddToBasketSuccessEventData } from '@df/session/api/basket/basket.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import find from 'lodash-es/find';
import { TradeStoreService } from '../../multisite/trade/trade-store.service';
import { NotificationService } from '../../ui/notification/notification.service';
import { BasketAddPromoGiftService } from '../add-promo-gift/basket-add-promo-gift.service';
import { BasketAddNotice } from './basket-add-notice.namespace';
import { LocalBasketItem } from '../../customer/basket/basket-item.decorator';

@Injectable({
    providedIn: 'root'
})
export class BasketAddNoticeInitiatorService extends AbstractDfModalInitiatorService<BasketAddNotice.IModalData> {
    private lastRouterEvent?: NavigationEnd | NavigationStart | NavigationError | NavigationCancel;
    constructor(
        DfModalService: DfModalService,
        app: App,
        private basketService: BasketService,
        private tradeStoreService: TradeStoreService,
        private notificationService: NotificationService,
        private basketAddPromoGiftService: BasketAddPromoGiftService
    ) {
        super(DfModalService, app);
        this.app.meta.routerEvents.subscribe(event => {
            this.lastRouterEvent = event;
        });
    }
    listen(cb: (eventData) => void): Promise<void> {
        return new Promise(resolve => {
            this.basketService.addToBasketSuccessUpdateSubject.subscribe(async (eventData: IAddToBasketSuccessEventData) => {
                const addedItemsQty = eventData?.request?.products.length;
                const request = eventData?.request?.products?.[0];
                const basketItem = this.app.customer.basket.byAddToBasketRequest(request) as LocalBasketItem;
                var giftItem;
                if (eventData.response?.amastyPromoGiftProducts && this.app.client.sizeId < 2) {
                    const giftProductId = await this.basketAddPromoGiftService.getPromoProduct(eventData.response?.amastyPromoGiftProducts);
                    giftItem = find(
                        this.app.customer.basket.items,
                        item =>
                            (item.data.product === giftProductId ||
                                (typeof giftProductId === 'string' && item.product?.data?.id === parseInt(giftProductId))) &&
                            item.data.request?.options?.ampromo_rule_id
                    );
                }
                if (basketItem && !eventData.response?.preventMinibasketOpen) {
                    if (!this.tradeStoreService.isTradeStore()) {
                        if (this.app.client.isS && !(this.lastRouterEvent instanceof NavigationStart)) {
                            cb({ basketItem, request, addedItemsQty, giftItem });
                        }
                    } else {
                        this.notificationService.add({
                            title: 'Added to basket',
                            duration: 2500,
                            variant: 'basket',
                            basketItem: basketItem
                        });
                    }
                }
            });
            resolve();
        });
    }
}
